import { HorizontalContainer } from '@picsart/design-system/components/HorizontalContainer';
import { Skeleton } from '@picsart/design-system/components/Skeleton';
import { MasonryGridSkeleton } from 'components/TemplatesMasonryGrid';
import classNames from 'classnames';
import useStyles from './styles';

const SingleTemplateSkeleton = () => {
  const classes = useStyles();

  return (
    <HorizontalContainer>
      <Skeleton className={classNames(classes.navigation, classes.skeleton)} />
      <div className={classes.wrapper}>
        <div className={classes.slider}>
          <Skeleton className={classNames(classes.sliderImage, classes.skeleton)} />
          <Skeleton className={classNames(classes.description, classes.skeleton)} />
        </div>
        <div className={classes.content}>
          <MasonryGridSkeleton />
        </div>
        <div className={classes.aside}>
          <Skeleton className={classNames(classes.asideItem1, classes.skeleton)} />
          <Skeleton className={classNames(classes.asideItem2, classes.skeleton)} />
          <Skeleton className={classNames(classes.asideItem3, classes.skeleton)} />
          <Skeleton className={classNames(classes.asideItem4, classes.skeleton)} />
          <Skeleton className={classNames(classes.asideItem5, classes.skeleton)} />
        </div>
      </div>
    </HorizontalContainer>
  );
};

export default SingleTemplateSkeleton;
